module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach2",
      "title": "Things That Remind Me of Home"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch2"
    }
  }, [_vm._v("Things That Remind Me of Home")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch2"
    }
  }, [_vm._v("Kimiko Hahn")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbb"
  }, [_c('i', [_vm._v("after Sei Shōnagon")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("moth balls")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("turpentine, curried chicken in the pressure cooker, gardenia—")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("From the living room, the sound of her Singer [Cast Iron, 1895] [same year her father was born in Hiroshima-ken]. The speed of the tapping depended on her knee pressure. Mother sewed doll clothes from her own dress hems. "), _c('i', [_vm._v("For me.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem1"
  }, [_vm._v("the taste of sumi-e ink")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("kitty litter box nest to the black phone mulch")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("transistor radio, car radio, record player")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("My student misses home, a “res” out west. “Every boulder and plant has a story and the story is about origin. About home.” I am never homesick for places—only people.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Mr. Cook—retired Chinese merchant marine so-named by our super—sees me as I walk by an OTB on Ninth "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("Avenue. This is years after I’ve moved out of our shabby apartment building on West 105th St. but he immediately recognizes me. He waves and hurries up to me, saying, “My wife, she went home.” Yes. Home. Ashes.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“Show me your green card.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Mr. C. stuffed his two-bedroom apartment full of newspapers, Playbills, photographs of stars and of himself, shoes from every photo shoot he’d been on, his wife’s dresses over their thirty-two-year marriage, and so on. To meet him in the elevator, one would think, “A nice tidy eccentric who plays rabbis or wizards in adverts.” Unless you looked at his limp black jacket, dandruff and mustard on his lapel. When the landlord told him to clean out or clear out, they got a dumpster. He died three months later.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("A bar in Charleston, West Virginia, 1981, the man next to me says, “Where you from?” I say, “New York.” He asks again and I smile and repeat, “I’m from New York.” He says, “You look like a girl I knew in Saigon.”")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("“Home is the place where, when you have to go there,")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("They have to take you in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentr"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("“I should have called it")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Something you somehow haven’t to deserve.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("お握り"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('i', [_vm._v("Trudy")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Turpentine from those large orange and black cans. (But do these things convey home or homesick? I cannot tell the difference, it seems.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This is the kitchen where mother lifted me onto the porcelain sink and sponge-bathed me. In the 105th Street kitchen, I gave sponge baths to our little girls. (The kitchen where the linoleum curled up and cockroaches nested and startled when the light was turned on, the constant smell of them, even with the window open to the sooty outdoors.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Meggie and I cleared a space under the forsythia at the bottom of her driveway to eat Ritz crackers. Barbara and I dug out homes for our trolls in the gnarly hickory roots. Yesterday, Meena and I sipped martinis and she held my hand saying, “You must take care of yourself, dear Kimiko.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('i', [_vm._v("Deviled Ham")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("漬物"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#fn3",
      "id": "rfn3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("stairwell, the Rittenhouse Hotel, the floor of his office, café, car, dogwood, shower stall")]), _vm._v(" "), _c('p', {
    staticClass: "footnote3",
    attrs: {
      "id": "fn1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn1"
    }
  }, [_vm._v("1.")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Excerpt of poetry from Robert Frost’s “The Death of the Hired Man.”")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "fn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn2"
    }
  }, [_vm._v("2.")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("お握り—onigiri—rice balls")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "fn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#rfn3"
    }
  }, [_vm._v("3.")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("漬物—tsukemono—Japanese pickles")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b85902","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter02.vue
// module id = 75
// module chunks = 0